/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllCommentsTabCommentContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_viewer" | "CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "AllCommentsTabCommentContainer_viewer";
};
export type AllCommentsTabCommentContainer_viewer$data = AllCommentsTabCommentContainer_viewer;
export type AllCommentsTabCommentContainer_viewer$key = {
    readonly " $data"?: AllCommentsTabCommentContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabCommentContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'd5a5858204f9bb18d127828e3ca58fd0';
export default node;
